export const AUTO_OPEN_URL_KEY = 'open';
